<template>
    <div>
        <table role="table" class="p-datatable-table">
            <tbody class="p-datatable-tbody" role="rowgroup">
                <tr v-for="(InspectionLine, inspectionIndex) in props.items" :key='inspectionIndex' class role="row" draggable="false">
                    <td class="item" role="cell">
                        <span class="p-column-title">Item</span>
                        <div class="row" style="display:flex;justify-content:space-between;">
                            <div class="title" style="flex-grow:1;">
                                <h4 class="title">{{ InspectionLine.Title }}</h4>
                                <div v-if="InspectionLine.Comment" class="notes" style="margin-left:2rem;">
                                    <p style="margin-bottom:0;"><strong>Comment:</strong> {{ InspectionLine.Comment }}</p>
                                </div>
                                <div v-if="InspectionLine.Notes" class="notes" style="margin-left:2rem;">
                                    <p style="margin-bottom:0;"><strong>Notes:</strong> {{ InspectionLine.Notes }}</p>
                                </div>
                                <div v-if="InspectionLine.Unit !== ''" class="notes" style="margin-left:2rem;">
                                    <p style="margin-bottom:0;"><strong>Measurements: </strong>
                                        LF: {{ InspectionLine.LF + InspectionLine.UnitText }}
                                        RF: {{ InspectionLine.RF + InspectionLine.UnitText }}
                                        LR: {{ InspectionLine.LR + InspectionLine.UnitText }}
                                        RR: {{ InspectionLine.RR + InspectionLine.UnitText }}
                                    </p>
                                </div>
                                <div v-if="InspectionLine.MediaKeys.length" class="documents" style="margin-left:2rem;">
                                    <p style="margin-bottom:0;"><strong>Upload(s):</strong></p>
                                    <div class="p-image p-image-preview-container item-image" v-for="(media, mediaKeyIndex) in InspectionLine.MediaKeys"
                                        v-bind:key="mediaKeyIndex" style="margin-right:1.5rem;">
                                        <template v-if="media.includes('|') === false"> 
                                            <Image
                                                :inspection-index="inspectionIndex"
                                                :media-index="mediaKeyIndex"
                                                class="p-overlay-badge"
                                                alt="Image"
                                                width="150"
                                                preview
                                                :src="media"
                                            />
                                        </template>
                                        <template v-else>
                                            <div class="video-container">
                                                <i class="pi pi-play"></i>
                                                <Image
                                                    :inspection-index="inspectionIndex"
                                                    :media-index="mediaKeyIndex"
                                                    alt="Image"
                                                    width="150"
                                                    :src="getThumbnail(media)"
                                                    @click="event => openVideoPopup(event, media)"
                                                    @error="handleImageError(inspectionIndex, mediaKeyIndex, '/default_no_video.png')"
                                                />
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="preview-modal" id="PreviewModal">
            <span class="close" id="closeButton" @click="closeVideoPopup">&times;</span>
            <img class="modal-content" id="previewNoVideo" src="/default_no_video.png" alt="Image" style="display: none;">
            <video class="modal-content" id="previewVideo" style="display:none" controls autoplay>
                <source />
            </video>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { defineProps } from 'vue';

const props = defineProps(['items']);

const getThumbnail = (media: string) => {
    return media.split('|')[0];
}

const getVideo = (media: string) => {
    return media.split('|')[1];
}

const openVideoPopup = async (event, media) => {

    if (event.target.src.endsWith('/default_no_video.png') === true) {
        return;
    }
    
    const modalImage = document.getElementById("previewNoVideo");
    modalImage.style.display = 'none';

    const previewModal = document.getElementById("PreviewModal");
    previewModal.style.display = 'block';

    const modalVideo = document.getElementById("previewVideo");
    modalVideo.style.display = 'block';

    const baseUrl = getVideo(media); // https://api-files.sproutvideo.com/file/0690d2b11d1aefcf8f/7d38b83fb71f18a6/
    const resolutions = ["720", "480", "360", "240"];
    const videoAssets = resolutions.map(resolution => `${baseUrl}${resolution}.mp4`);
    let isValid = false;
    for (let index=0; index < videoAssets.length; index++) {
        const response = await fetch(videoAssets[index]);
        if (response.status >= 200 && response.status < 400) {
            modalVideo.src = videoAssets[index];
            isValid = true;
            break; // this is to stop the iteration
        }
    }
    
    if (isValid === false) {
        modalVideo.style.display = 'none';
        modalImage.style.display = 'block';
    }
}

const handleImageError = (inspectionIndex, mediaKeyIndex, srcImg) => {
    const errorImage: HTMLImageElement | null = document.querySelector(`img[inspection-index="${inspectionIndex}"][media-index="${mediaKeyIndex}"]`);
    if (errorImage) {
        errorImage.src = srcImg;
    }
}

const closeVideoPopup = () => {
    let previewModal = document.getElementById("PreviewModal");
    previewModal.style.display = 'none';
    let modalVideo = document.getElementById("previewVideo");
    modalVideo.src = null;
}
</script>